import { createApp } from "vue";
import { createPinia } from "pinia";
import Tabs from "./components/Tabs/Tabs";
import ProductSliderApp from "./components/Sliders/SliderMain";
import ProductCharApp from "./components/CharacteristicBlock/CharacteristicBlock";
import ProductDetailsApp from "./components/DescriptionBlock/DescriptionBlock";
import ProductOfferCodeApp from "./components/OfferCode/OfferCode";
import ProductOfferPriceApp from "./components/OfferPrice/OfferPrice";
import ProductFavoritesApp from "./components/FavoriteButton/FavoriteButton";
import ProductBasketButtonApp from "./components/Basket/BasketButton";
import ProductBadgesApp from "./components/Badges/BadgeDetail";
import ProductRecommendedApp from "./components/Sliders/SliderProducts";
import ProductActionsApp from "./components/Action/ActionWrap";
import ProductColorsApp from "./components/ColorsWrap/ColorsWrap";
import ProductDeliveryApp from "./components/Delivery/DeliveryTime";
import ProductSizesApp from "./components/Properties/Sizes";
import ProductParamsApp from "./components/Properties/PropertiesBlock";
import ProductCharAppMobile from "./components/CharacteristicDropdown/CharacteristicDropdown";
import ProductName from "./components/Product/ProductName";
import ProductVideoCall from "./components/Product/ProductVideoCall";
import ProductSpecial from "./components/Product/ProductSpecial";
import { useReviewsStore } from "@/pages/product_card/stores/store_reviews";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { useRecommendedStore } from "@/pages/product_card/stores/store_recommended";
import "@/pages/product_card/assets/scss/style.scss";

const pinia = createPinia();
const productFavoritesApp = createApp(ProductFavoritesApp);
productFavoritesApp.use(pinia);
productFavoritesApp.mount("#product-favorites");

const productStore = useProductStore();
const recommendedStore = useRecommendedStore();
const reviewsStore = useReviewsStore();

productStore.fillProductInfo(window.dataApp.products);
productStore.fillSpecial(window.dataApp.special_features);
productStore.fillOffersInfo(window.dataApp.offers);

document.getElementById("product-installments").classList.remove("d-none");

window.dataLayer = window.dataLayer || [];
try {
  window.dataLayer.push({
    event: "view_item",
    ecommerce: {
      currency: "RUB",
      items: [
        {
          item_name: productStore.getSelectedProduct.name,
          item_id:
            productStore.getSelectedOffer?.kod_torgovogo_predlozheniya.replaceAll(
              "-",
              ""
            ),
          price: productStore.getMinimalPrice + ".00",
          item_brand: productStore.getSelectedProduct.props?.brand ?? "",
          item_category: productStore.getSelectedProduct.section?.name ?? "",
          quantity: "1",
        },
      ],
    },
  });
} catch (e) {
  console.log("error event sending");
}

productStore.basket.list = window.dataApp?.basket?.list;
productStore.basket.count = window.dataApp.basket.list.length;

reviewsStore.fillData(window.dataApp.reviews);

productStore.loadWishList();

recommendedStore.products = window.dataApp?.recommended;

const productSliderApp = createApp(ProductSliderApp);
productSliderApp.use(pinia);
productSliderApp.mount("#product-slider");

const productVideoCallApp = createApp(ProductVideoCall);
productVideoCallApp.use(pinia);
productVideoCallApp.mount("#product-video-call");

const productSpecialApp = createApp(ProductSpecial);
productSpecialApp.use(pinia);
productSpecialApp.mount("#special-features");

const productCharApp = createApp(ProductCharApp);
productCharApp.use(pinia);
productCharApp.mount("#product-characteristic");

const productDetailsApp = createApp(ProductDetailsApp);
productDetailsApp.use(pinia);
productDetailsApp.mount("#product-details");

const productOfferCodeApp = createApp(ProductOfferCodeApp);
productOfferCodeApp.use(pinia);
productOfferCodeApp.mount("#offer-code");

const productOfferPriceApp = createApp(ProductOfferPriceApp);
productOfferPriceApp.use(pinia);
productOfferPriceApp.mount("#offer-prices");

const productBadgesApp = createApp(ProductBadgesApp);
productBadgesApp.use(pinia);
productBadgesApp.mount("#product-badges");

const productBasketButtonApp = createApp(ProductBasketButtonApp);
productBasketButtonApp.use(pinia);
productBasketButtonApp.mount("#product-basket-button");

const productRecommendedApp = createApp(ProductRecommendedApp);
productRecommendedApp.use(pinia);
productRecommendedApp.mount("#product-recommended");

const productActionsApp = createApp(ProductActionsApp);
productActionsApp.use(pinia);
productActionsApp.mount("#product-actions");

const productColorsApp = createApp(ProductColorsApp);
productColorsApp.use(pinia);
productColorsApp.mount("#product-properties-colors");

const productDeliveryApp = createApp(ProductDeliveryApp, {
  delivery: window.dataApp.delivery,
});
productDeliveryApp.use(pinia);
productDeliveryApp.mount("#product-delivery");

const productSizesApp = createApp(ProductSizesApp);
productSizesApp.use(pinia);
productSizesApp.mount("#product-sizes");

const productParamsApp = createApp(ProductParamsApp);
productParamsApp.use(pinia);
productParamsApp.mount("#product-params");

const productCharAppMobile = createApp(ProductCharAppMobile);
productCharAppMobile.use(pinia);
productCharAppMobile.mount("#product-characteristic__mobile");

const productName = createApp(ProductName);
productName.use(pinia);
productName.mount("#product-name");

const tabs = createApp(Tabs);
tabs.use(pinia);
tabs.mount("#product-review-tabs");

/** Событие: Просмотр карточки товара **/
document.dispatchEvent(
  new CustomEvent("Website.ViewProduct", {
    detail: {
      productId: productStore.getSelectedProduct.id,
    },
  })
);
document.addEventListener("selectOfferByIdEvent", async (event) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "ymUserParamsChanged",
    ym_user_params: {
      "Product card view": event.detail.params,
    },
  });
});

document.dispatchEvent(
  new CustomEvent("selectOfferByIdEvent", {
    detail: {
      params: productStore.getUserParamsChanged(),
    },
  })
);
